import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { SingleDatePicker } from 'react-dates'
import 'react-dates/initialize'

import 'react-dates/lib/css/_datepicker.css'

import ThemedStyleSheet from 'react-with-styles/lib/ThemedStyleSheet';
import aphroditeInterface from 'react-with-styles-interface-aphrodite';
import DefaultTheme from 'react-dates/lib/theme/DefaultTheme';


ThemedStyleSheet.registerInterface(aphroditeInterface)
ThemedStyleSheet.registerTheme({
    reactDates: {
        ...DefaultTheme.reactDates,
        color: {
            ...DefaultTheme.reactDates.color,
            highlighted: {
                backgroundColor: '#4F1B68',
                backgroundColor_active: '#4F1B68',
                backgroundColor_hover: '#4F1B68',
                color: '#186A3B',
                color_active: '#186A3B',
                color_hover: '#186A3B',
            },
        },
    }
})

export default class DatePicker extends React.PureComponent {

    static propTypes = {
        date: PropTypes.object,
        _onChange: PropTypes.func.isRequired,
        focused: PropTypes.bool.isRequired,
        _onFocusedChange: PropTypes.func.isRequired
    }

    render() {

        const { date, _onChange, focused, _onFocusedChange } = this.props
        return (
            <SingleDatePicker
                date={date} // momentPropTypes.momentObj or null
                onDateChange={_onChange('date')} // PropTypes.func.isRequired
                focused={focused} // PropTypes.bool
                onFocusChange={_onFocusedChange} // PropTypes.func.isRequired
                placeholder='เลือกวันที่'
                small={true}
                numberOfMonths={1}
                anchorDirection='right'
                displayFormat='DD/MM/YYYY'
            />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Regular/DatePicker.js